<template>
  <HeadlessLayout :sections="content" />
</template>

<script>
import SustainabilityMainContent from "@/content/SustainabilityMain.json";
import HeadlessLayout from "@/layouts/HeadlessLayout.vue";

export default {
  name: "Sus",
  components: {
    HeadlessLayout,
  },
  data() {
    return {
      content: SustainabilityMainContent,
    };
  },
};
</script>
